import PortfolioLocations from '../navPages/PortfolioLocations' // _OLD
import PortfolioNotes from '../navPages/PortfolioNotes'
import PortfolioChat from '../navPages/PortfolioChat'
import PortfolioTasksCN from '../navPages/PortfolioTasksCN'
import PortfolioImages from '../navPages/PortfolioImages'
import PortfolioDocumentsCN from '../navPages/PortfolioDocumentsCN'
import PortfolioFinancials from '../navPages/PortfolioFinancials'
import PortfolioReports from '../navPages/PortfolioReports'
import PortfolioPartners from '../navPages/PortfolioPartners'
import {
	MapPin,
	StickyNote,
	MessageSquare,
	ListTodo,
	Images,
	FileText,
	DollarSign,
	FileBarChart,
	Handshake,
} from 'lucide-react'
import routes from 'constants/routes'
import type { Capabilities, PartnerAccessLevel } from '../../../utils/capabilities'
import { normalizeAccessLevel } from '../../../utils/capabilities'

/**
 * Nav for someone viewing a portfolio they partner on rather than own.
 *
 * Financials and Reports are gated twice: by the viewer's account tier
 * (`capabilities.canSeeFinancials`, same predicate the other three route files
 * use) and by their per-asset grant on this portfolio. A read-only partner
 * never sees them; a full-access partner sees them only if their account tier
 * allows financials at all. The backend enforces the same intersection, so
 * these tabs are a UX decision, not the security boundary.
 *
 * Edit, Add Locations and the owner-only actions stay absent for every partner.
 */
const getPortfolioPartnerRoutes = (
	id: string,
	capabilities?: Capabilities,
	accessLevel?: PartnerAccessLevel | string | null
) =>
	[
		{
			linkText: 'Locations',
			linkTo: `${routes.PORTFOLIOS}/${id}/locations`,
			linkPattern: `${routes.PORTFOLIOS}/:id/locations`,
			icon: MapPin,
			component: PortfolioLocations,
		},
		{
			linkText: 'Tasks',
			linkTo: `${routes.PORTFOLIOS}/${id}/tasks`,
			linkPattern: `${routes.PORTFOLIOS}/:id/tasks`,
			icon: ListTodo,
			component: PortfolioTasksCN,
		},
		{
			linkText: 'Notes',
			linkTo: `${routes.PORTFOLIOS}/${id}/notes`,
			linkPattern: `${routes.PORTFOLIOS}/:id/notes`,
			icon: StickyNote,
			component: PortfolioNotes,
		},
		{
			linkText: 'Chat',
			linkTo: `${routes.PORTFOLIOS}/${id}/chat`,
			linkPattern: `${routes.PORTFOLIOS}/:id/chat`,
			icon: MessageSquare,
			component: PortfolioChat,
		},
		{
			linkText: 'Financials',
			linkTo: `${routes.PORTFOLIOS}/${id}/financials`,
			linkPattern: `${routes.PORTFOLIOS}/:id/financials`,
			icon: DollarSign,
			component: PortfolioFinancials,
		},
		{
			linkText: 'Images',
			linkTo: `${routes.PORTFOLIOS}/${id}/images`,
			linkPattern: `${routes.PORTFOLIOS}/:id/images`,
			icon: Images,
			component: PortfolioImages,
		},
		{
			linkText: 'Documents',
			linkTo: `${routes.PORTFOLIOS}/${id}/files`,
			linkPattern: `${routes.PORTFOLIOS}/:id/files`,
			icon: FileText,
			component: PortfolioDocumentsCN,
		},
		{
			linkText: 'Partners',
			linkTo: `${routes.PORTFOLIOS}/${id}/partners`,
			linkPattern: `${routes.PORTFOLIOS}/:id/partners`,
			icon: Handshake,
			component: PortfolioPartners,
		},
		{
			linkText: 'Reports',
			linkTo: `${routes.PORTFOLIOS}/${id}/reports`,
			linkPattern: `${routes.PORTFOLIOS}/:id/reports`,
			icon: FileBarChart,
			component: PortfolioReports,
		},
		/*
			Redirect routes
		*/
		{
			redirectFrom: `${routes.PORTFOLIOS}/:id`,
			redirectTo: `${routes.PORTFOLIOS}/${id}/locations`,
		},
	].filter((route: any) => {
		if (route.linkText === 'Financials' || route.linkText === 'Reports') {
			if (normalizeAccessLevel(accessLevel as string) === 'readonly') return false
			return !capabilities || capabilities.canSeeFinancials
		}
		return true
	})

export default getPortfolioPartnerRoutes
